import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Grid,
  Group,
  Input,
  NumberFormatter,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconFileTypography,
  IconRefresh,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { modals } from "@mantine/modals";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import {
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import InputSearch from "../../../common/InputSearch/InputSearch";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import DeleteTicket from "./DeleteTicket";
import DetailSupplierSlip from "./DetailSupplierSlip.tsx";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { useDebouncedCallback, useMediaQuery } from "@mantine/hooks";
import { SaveKeySearch } from "../../../common/SaveKeySearch/SaveKeySearch";
import { IconFileSearch } from "@tabler/icons-react";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { DatePickerInput } from "@mantine/dates";

interface dataItemDetail {
  id: string;
  maCty: string;
  maCt: string;
  maNCC: string;
  tenNCC: string;
  nguoiGd: string;
  maHttt: string;
  tenHttt: string;
  tkPt: string | null;
  dienGiai: string | null;
  soSeri: string | null;
  soCt: string;
  ngayCt: string; // Date string in ISO format
  ngayLct: string; // Date string in ISO format
  ngayHd: string; // Date string in ISO format
  soHd: string | null;
  maTtPo: string;
  hanCk: number;
  tlCk: number;
  hanTt: number;
  lsQh: number;
  maNt: string;
  tyGia: number;
  tTienNt0: number;
  tTien0: number;
  tCpNt: number;
  tCp: number;
  tTienNt: number;
  tTien: number;
  tThueNt: number;
  tThue: number;
  tTienCkNt: number;
  tTienCk: number;
  tTienCkDhNt: number;
  tTienCkDh: number;
  tkCk: string;
  tGg: number;
  tGgNt: number;
  tTt: number;
  tTtNt: number;
  tSoLuong: number;
  suaTien: string;
  suaThue: string;
  taoTuDh: string;
  ghiChu: string | null;
  trangThai: string;
  ssNcc: string | null;
  hdGtgt: string;
  tenHdGtgt: string;
  noHd: string;
  khongLayHd: string;
  barcode: string;
  httt: string;
  maBp: string;
  soCtKh: string | null;
  soCtDhm: string | null;
  tenKl: string | null;
  nguoiDuyetPo1: string;
  tenNguoiDuyetPo1: string;
  ngayDuyetPo1: string; // Date string in ISO format
  duyetPo2: string;
  nguoiDuyetPo2: string;
  tenNguoiDuyetPo2: string;
  ngayDuyetPo2: string; // Date string in ISO format
  nguoiHuyDuyetPo2: string | null;
  tenNguoiHuyDuyetPo2: string | null;
  ngayHuyDuyetPo2: string; // Date string in ISO format
}

interface DataList {
  data: dataItemDetail[];
  totalCount: number;
}

export const SupplierSlipExport = () => {
  //#region  table
  //data and fetching state
  const [data, setData] = useState<dataItemDetail[]>([]);
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [height, setHeight] = useState(0);
  const [user, setUser] = useState<any>(null);
  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  // Chỉ cho phép gọi fetchData sau khi đã lấy xong mã chi nhánh mặc định (lần đầu vào trang)
  const [isReadyBranch, setIsReadyBranch] = useState(false);

  const [search, setSearch] = useState({
    keySearch: "",
    customerId: "",
    startDate: "",
    endDate: "",
    codefund: "",
    Manv: "",
    accountfund: "",
    deartment: "",
    branch: "",
    type: "",
    workplace: "",
    creator: "",
    Type: 0,
    FromDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    EndDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    Loai: null,
    TrangThai: null,
  });
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const payerTypeOptions = [
    { value: "HOAN_THANH", label: "Hoàn thành" },
    { value: "CHUA_XUAT", label: "Chưa xuất" },
    { value: "DANG_XUAT", label: "Đang xuất" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      const queryParams = {
        Skip: pagination.pageIndex * pagination.pageSize,
        Take: pagination.pageSize,
        KeySearch: search.keySearch,
        MaNCC: search.Manv,
        MaCN: search.branch,
        FromDate: search.FromDate,
        EndDate: search.EndDate,
        ...(search.Loai != null &&
          search.Loai !== "" && { Loai: Number(search.Loai) }),
        ...(search.TrangThai != null &&
          search.TrangThai !== "" && { TrangThai: search.TrangThai }),
      };

      let sortingQuery = "";
      if (sorting && sorting.length > 0) {
        const { id, desc } = sorting[0] || {};
        if (id) {
          sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
        }
      }

      const url =
        Object.entries(queryParams)
          .reduce((acc, [key, value]) => {
            if (value !== undefined && value !== "") {
              return `${acc}&${key}=${encodeURIComponent(value)}`;
            }
            return acc;
          }, "/api/v1/ImportBill/get-list?Type=2")
          .replace("?&", "?") + sortingQuery;

      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        setData(response?.data);
        setRowCount(response?.totalCount);
        table.resetRowSelection();
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const DeleteCancelOrder = (PIds: number) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Hủy đơn hàng!</Title>
        </>
      ),
      size: "auto",
      children: <DeleteTicket PIds={PIds} onSearch={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleChangeSearchValue = useDebouncedCallback(
    (value: string, key: string) => {
      const trimmedValue = value.trim();
      setSearch((prevData) => ({ ...prevData, [key]: trimmedValue }));
    },
    500,
  );

  const openModal = (id: string) =>
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết phiếu nhà cung cấp!</Title>
        </>
      ),
      size: "90%",
      children: <DetailSupplierSlip id={id} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const handleReload = () => {
    window.location.reload();
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "soCt",
        header: "Số chứng từ",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              style={{ cursor: "pointer" }}
              onDoubleClick={() => openModal(row.original.id)}
              variant="filled"
              radius="xl"
            >
              {renderedCellValue === null
                ? "Không xác định"
                : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        size: 120,
      },
      {
        accessorKey: "ngayCt",
        header: "Ngày chứng từ",
        Cell: ({ renderedCellValue }: any) => {
          return <>{formatDateTransfer(renderedCellValue)}</>;
        },
      },
      {
        accessorKey: "maGiaoDichKho",
        header: "Mã phiếu xuất kho",
        Cell: ({ renderedCellValue }: any) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ngayGiaoDichKho",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          return <>{formatDateTransfer(renderedCellValue)}</>;
        },
      },
      {
        accessorKey: "plNhapTra",
        header: "Loại phiếu",
        size: 230,
        Cell: ({ row }: { row: { original: { plNhapTra?: number } } }) => {
          const { plNhapTra } = row?.original || {};

          const statusMap: Record<number, { color: string; label: string }> = {
            6: { color: "orange", label: "Xuất công cụ dụng cụ" },
            4: { color: "blue", label: "Xuất khác" },
            2: { color: "violet", label: "Xuất trả nhà cung cấp" },
          };

          const { color = "gray", label = "Không xác định" } =
            statusMap[plNhapTra!] || {};

          return (
            // <Badge variant="light" bd={`1px solid ${color}`} color={color}>
            //   {label}
            // </Badge>
            <>{label}</>
          );
        },
      },
      {
        accessorKey: "maNCC",
        header: "Mã nhà cung cấp",
        Cell: ({ renderedCellValue }: any) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNCC",
        header: "Tên nhà cung cấp",
        size: 250,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },

      {
        accessorKey: "id",
        header: "ID giao dịch",
        Cell: ({ renderedCellValue }) => {
          return <Text fw={600}>{renderedCellValue}</Text>;
        },
      },
      {
        accessorKey: "ttNhapHang",
        header: "Tình trạng nhập hàng",
        Cell: ({ renderedCellValue }) => {
          const payerType = renderedCellValue;
          let badgeColor = "gray"; // Default badge color
          let text = "Không xác định"; // Default text

          // Assign colors and text based on payerType
          switch (payerType) {
            case "HOAN_THANH":
              badgeColor = "green"; // Represents success
              text = "Hoàn thành";
              break;
            case "CHUA_NHAP":
              badgeColor = "violet"; // Represents awaiting or unprocessed state
              text = "Chưa nhập";
              break;
            case "DA_NHAP":
              badgeColor = "yellow"; // Indicates processed or completed state
              text = "Đã nhập";
              break;
            case "CHUA_XUAT":
              badgeColor = "gray"; // Neutral, as it's not yet exported
              text = "Chưa xuất";
              break;
            case "DANG_NHAP":
              badgeColor = "orange"; // Represents ongoing processes
              text = "Đang nhập";
              break;
            case "DANG_XUAT":
              badgeColor = "blue"; // Indicates export in progress
              text = "Đang xuất";
              break;
            default:
              badgeColor = "gray"; // Default fallback color
              text = "Không xác định";
              break;
          }
          // Render Badge with assigned styles
          return (
            <Badge
              variant="light"
              bd={`1px solid ${badgeColor}`}
              color={badgeColor}
              radius="sm"
            >
              {text}
            </Badge>
          );
        },
      },
      {
        accessorKey: "maCty",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            style={{ cursor: "pointer" }}
            variant="light"
            radius="xl"
            color="violet"
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "httt",
        header: "Hình thức thanh toán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "nguoiGd",
        header: "Người giao dịch",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "tTien0",
        header: "Tổng tiền ",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <Text fw={600}>
            <NumberFormatter
              value={(renderedCellValue as string | number) || 0}
              thousandSeparator=","
            />
          </Text>
        ),
      },
      {
        accessorKey: "tTt",
        header: "Tổng thanh toán",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <Text fw={600}>
            <NumberFormatter
              value={(renderedCellValue as string | number) || 0}
              thousandSeparator=","
            />
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableResizing: false,
        size: 100,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) =>
          row?.original.plNhapTra && (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {row?.original.plNhapTra === 1 ? (
                <Tooltip label={"Tạo phiếu nhập"}>
                  <ActionIcon
                    variant="light"
                    disabled={
                      row.original.ttNhapHang === "HOAN_THANH" ||
                      row.original.ttNhapHang === "DANG_XUAT"
                    }
                    aria-label="Request"
                    color="blue"
                    onClick={async () => {
                      navigate(`/warehouse-config/create-warehouse-in-ward`, {
                        state: {
                          branchCode: row.original.maCty,
                          sourceType: "NHAP_HANG_NCC",
                          sourceCode: row.original.id,
                        },
                      });
                    }}
                  >
                    <IconArrowNarrowRight size={20} stroke={2} />
                  </ActionIcon>
                </Tooltip>
              ) : (
                <Tooltip label={"Tạo phiếu xuất"}>
                  <ActionIcon
                    variant="light"
                    aria-label="Request"
                    color="blue"
                    disabled={
                      row.original.ttNhapHang === "DANG_XUAT" ||
                      row.original.ttNhapHang === "HOAN_THANH"
                    }
                    onClick={async () => {
                      let sourceType = "";

                      switch (row.original.plNhapTra) {
                        case 2:
                          sourceType = "XUAT_TRA_NCC";
                          break;
                        case 4:
                          sourceType = "XUAT_KHAC";
                          break;
                        case 6:
                          sourceType = "XUAT_CONG_CU_DUNG_CU";
                          break;
                      }
                      navigate(`/warehouse-config/create-warehouse-out-ward`, {
                        state: {
                          sourceType,
                          sourceCode: row.original.soCt,
                        },
                      });
                    }}
                  >
                    <IconArrowNarrowRight size={20} stroke={2} />
                  </ActionIcon>
                </Tooltip>
              )}
              <Tooltip label={"Xóa phiếu"}>
                <ActionIcon
                  variant="light"
                  disabled={row.original.ttNhapHang === "HOAN_THANH"}
                  aria-label="Request"
                  color="red"
                  onClick={() => {
                    DeleteCancelOrder(row.original?.pId);
                  }}
                >
                  <IconTrash size={20} stroke={2} />
                </ActionIcon>
              </Tooltip>
            </Box>
          ),
      },
    ],
    [],
  );

  const table = useMantineReactTable<any>({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        // borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        // marginTop: "10px",
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    enableColumnActions: false,
    // getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "soCt", "mrt-row-select"],
        right: ["tTien0", "tTt", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    // enableExpanding: true,
    // getSubRows: (originalRow) => originalRow.orderDetail,
    mantineTableProps: {
      striped: false,
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (!isReadyBranch) return;
    fetchData();
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    refreshKeySearch,
    isReadyBranch,
  ]);

  useEffect(() => {
    const storedUser = localStorage.getItem("userLogin");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  useEffect(() => {
    if (!isReadyBranch) return;
    if (checkedPinSearch)
      setTimeout(() => {
        const runAsyncFunctions = async () => {
          const savedSearch = await SaveKeySearch(search, setSearch, 2);
          if (savedSearch) {
            setSearch(savedSearch);
            setRefreshKeySearch(savedSearch);
          }
        };
        runAsyncFunctions();
      }, 1000);
  }, [checkedPinSearch, window.location.pathname, isReadyBranch]);

  const updateTools = async () => {
    const x = dataBranch?.find(
      (x) => String(x.value) === String(user?.branchId),
    );
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/SyncInFromAsia/sync-from-asia-api",
      {
        message: "asia",
        typeMessage: "asia",
        type: 0,
        source: "asia",
        branchCode: x?.att2 ?? "",
      },
    );

    if (res && res?.success) {
      NotificationExtension.Success("Đồng bộ thành công");
      setTimeout(() => {
        fetchData();
      }, 2500);
    } else {
      NotificationExtension.Fails("Đồng bộ thất bại !");
    }
  };

  const fetchDataBranch = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >("/api/v1/TblDmInventory/get-select-branch?auth=false");

      if (response && response.success) {
        const result = response.data;
        const idBranchEmp = String(
          JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
            ?.branchId || "",
        );
        const dataSelect = result
          ?.filter((item) => item.text && item.att2)
          ?.map((item) => ({
            label: `${item.att2} - ${item.text}`,
            value: item.att2?.toString(),
          }));
        setDataBranch(result);
        setDataBranchSelect(dataSelect);
        setSearch((prev) => ({
          ...prev,
          branch:
            String(
              result.find((i: any) => String(i.value) === String(idBranchEmp))
                ?.att2 || "",
            ) || "",
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      // Dù thành công hay lỗi cũng mở khoá để trang vẫn load được dữ liệu
      setIsReadyBranch(true);
    }
  };

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    fetchDataBranch();
  }, []);

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group gap={0} justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Button
            color="blue"
            variant="light"
            leftSection={<IconRefresh size={17} />}
            bd="1px solid blue"
            onClick={() => {
              updateTools();
            }}
          >
            Đồng bộ công cụ dụng cụ
          </Button>
        </Group>
        <Grid mt={15}>
          <Grid.Col span={sizeGrid}>
            <InputSearch
              defaultValue={search.keySearch}
              width="100%"
              placeholder="Từ khoá"
              onChange={(value) => {
                handleChangeSearchValue(value, "keySearch");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDate && search.FromDate.length > 0
                  ? new Date(search.FromDate)
                  : null
              }
              clearable
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "FromDate",
                );
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.EndDate && search.EndDate.length > 0
                  ? new Date(search.EndDate)
                  : null
              }
              clearable
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "EndDate",
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Mã nhà cung cấp"
              type="text"
              onChange={(e) => {
                handleChangeSearchValue(e.target.value ?? "", "Manv");
              }}
              leftSection={<IconFileSearch color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chi nhánh"
              data={dataBranchSelect}
              value={search.branch || null}
              searchable
              clearable
              leftSection={<IconBrandBootstrap size={20} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearchValue(e ? e : "", "branch");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              leftSection={<IconFileTypography color="#15aabf" />}
              size="sm"
              placeholder="Chọn loại giao dịch"
              data={[
                { value: "6", label: "Xuất công cụ dụng cụ" },
                { value: "4", label: "Xuất khác" },
                { value: "2", label: "Xuất trả nhà cung cấp" },
              ]}
              onChange={(e) => {
                console.log("e", e);
                handleChangeSearchValue(e ?? "", "Loai");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              leftSection={<IconFileTypography color="#15aabf" />}
              size="sm"
              placeholder="Tình trạng nhập hàng"
              data={payerTypeOptions}
              onChange={(e) => {
                console.log("e", e);
                handleChangeSearchValue(e ?? "", "TrangThai");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
                localStorage.setItem(
                  "allValueKeySearch",
                  JSON.stringify({
                    ...search,
                    url: String(window.location.pathname),
                  }),
                );
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
